import React from 'react';
import translate from '@/utils/translate';
import type {PromotableLink} from '../shell/informationTypes';
import BriefSection from './BriefSection';
import CopyableValue from './CopyableValue';
import styles from './BriefBlocks.module.scss';

interface PromotableUrlItemProps {
  links: PromotableLink[];
}

/**
 * The caller gates on the campaign defining tracking URLs; the creator's own links
 * are only issued on acceptance, hence the placeholder branch.
 */
function PromotableUrlItem({links}: PromotableUrlItemProps) {
  const showLabels = links.length > 1;

  return (
    <BriefSection
      testID="brief-promotable-url"
      title={translate('Custom URL for Posting')}
      subtitle={translate(
        'You must link to the URL shown per the gig instructions.'
      )}
    >
      {links.length > 0 ? (
        <div className={styles.stack}>
          {links.map((link) => (
            <CopyableValue
              key={link.id}
              testID="brief-promotable-url-link"
              label={showLabels ? link.label : null}
              value={link.trackingUrl}
            />
          ))}
        </div>
      ) : (
        <p
          className={styles.placeholder}
          data-testid="brief-promotable-url-empty"
        >
          {translate(
            'URL will be shown here if you are accepted into this campaign.'
          )}
        </p>
      )}
    </BriefSection>
  );
}

export default PromotableUrlItem;
